/** * @Author: liujiannan * @Date: 2020-09-22 13:35:25 *
@Description首页个人中心 */
<template>
  <div class="person-center">
    <div class="person-center-header">
      <PersonCenterType
        v-model="type"
        :type-tabs="typeTabs"
        @changeType="changeType"
      />
      <PersonCenterUserInfo :user-info="userInfo" />
    </div>
    <PersonCenterMainFunctions :type="type" @routeToDetail="routeToDetail" />
    <PersonCenterSubFunctions :type="type" @routeToDetail="routeToDetail" />
  </div>
</template>
<script>
import { mapActions } from "vuex";
// 门诊/住院tab
import PersonCenterType from "./components/PersonCenterType";
// 用户信息
import PersonCenterUserInfo from "./components/PersonCenterUserInfo";
// 主菜单
import PersonCenterMainFunctions from "./components/PersonCenterMainFunctions";
// 次级菜单
import PersonCenterSubFunctions from "./components/PersonCenterSubFunctions";

export default {
  components: {
    PersonCenterType,
    PersonCenterUserInfo,
    PersonCenterMainFunctions,
    PersonCenterSubFunctions
  },
  data() {
    return {
      type: "outpatient", // outpatient 门诊 inpatient 住院
      typeTabs: [
        { name: "门诊", type: "outpatient" },
        { name: "住院", type: "inpatient" }
      ],
      userInfo: {}
    };
  },
  activated() {
    if (this.$route.query && this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.getUserInfo();
  },
  methods: {
    ...mapActions("users", ["getUserBaseInfo"]),
    changeType() {
      this.$router.replace({
        name: "mine",
        query: {
          type: this.type
        }
      });
      this.getUserInfo();
    },
    getUserInfo() {
      this.getUserBaseInfo(this.type === "outpatient" ? "1" : "2")
        .then(res => {
          this.userInfo = {
            ...res,
            cardNo: this.$regular.desensitization(res.cardNo, 3, -3),
            patientName: this.$regular.desensitization(res.patientName, 0, -1)
          };
        })
        .catch(error => {
          const notQRCode = error.errorCode == "502";
          this.$phdialog
            .confirm({
              message: error.message,
              closeOnClickOverlay: notQRCode,
              confirmButtonText: notQRCode ? "手动添加" : "确认",
              cancelButtonText: notQRCode ? "领用多码融合码" : "取消"
            })
            .then(() => {
              if (this.type === "outpatient") {
                this.$router.replace({
                  name: "home"
                });
              }
              this.$router.push({
                name: "relative-card",
                query: {
                  ftype: this.type === "outpatient" ? "1" : "2"
                }
              });
            })
            .catch(() => {
              if (notQRCode) {
                this.$router.replace({
                  name: "home"
                });
                this.$http.route("/ecode", "1");
              } else {
                this.$router.replace({
                  name: "outpatient"
                });
              }
            });
        });
    },
    routeToDetail(item) {
      if (item.path === "ecode") {
        this.$http.route("/ecode", "1");
        return;
      }
      this.$router.push({
        name: item.path,
        query: {
          ftype: this.type === "outpatient" ? "1" : "2"
        }
      });
    }
  }
};
</script>

<style lang="less">
.person-center {
  &-header {
    display: table;
    width: 100%;
    height: 11.5rem;
    background-color: #108eee;
  }
}
</style>
